const BREAKPOINT = 700

export default BREAKPOINT